module.exports = __webpack_public_path__ + "img/chart_active_24dp@2x.85a64bbd.png";